export enum DeliveredByEnum {
    DELIVERED_BY_KALPAY = 'delivered_by_kalpay',
    DELIVERED_BY_VENDOR = 'delivered_by_vendor',
}